import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { experiences } from '../data';
import { experiencePriceLabel } from '../quote/experiencePriceLabel';

const defaultPlanningNotes =
  'Want help figuring out if this is the right fit? Use the planning-help button and we’ll help you narrow down options, compare details, and coordinate next steps.';

const ProductPage = () => {
  const { id } = useParams();
  const experience = experiences.find((item) => item.id === id);

  const partnerPageUrl = experience?.partnerPageUrl;

  useEffect(() => {
    if (partnerPageUrl) {
      window.location.replace(partnerPageUrl);
    }
  }, [partnerPageUrl]);

  if (partnerPageUrl) {
    return (
      <main className="detail-page">
        <p>Opening {experience.name}’s Teamward page…</p>
        <a href={partnerPageUrl}>Continue to {experience.name}</a>
      </main>
    );
  }

  if (!experience) {
    return (
      <main className="detail-page not-found">
        <h1>Experience not found</h1>
        <Link to="/">Back to Teamward</Link>
      </main>
    );
  }

  const canUseBuilder = experience.city === 'Denver';
  const builderUrl = `/quote-builder?v=${encodeURIComponent(experience.id)}`;

  return (
    <main className="detail-page">
      <section
        className="detail-hero"
        style={{
          backgroundImage: `linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.82),
            rgba(0, 0, 0, 0.35)
          ), url(${experience.image})`,
          backgroundPosition: experience.imagePosition || 'center',
        }}
      >
        <div style={{ maxWidth: experience.heroTextWidth || undefined }}>
          <Link to="/" className="back-link">
            ← Back to experiences
          </Link>

          <div className="detail-meta-row">
            <p className="eyebrow">
              {experience.city}, {experience.state}
            </p>

            {experience.preferred && (
              <span className="preferred-partner-label">
                ✓ Preferred Partner
              </span>
            )}
          </div>

          <h1>{experience.name}</h1>
          <p>{experience.summary}</p>
        </div>
      </section>

      <section className="detail-content">
        <div className="detail-main">
          <h2>Why it works</h2>
          <p>{experience.details}</p>

          <h2>Best for</h2>
          <p>{experience.bestFor}</p>

          {experience.programs?.length > 0 && (
            <>
              <h2>Programs &amp; fees</h2>

              <div className="program-list">
                {experience.programs.map((program) => (
                  <div className="program-item" key={program.name}>
                    <div className="program-heading">
                      <h3>{program.name}</h3>
                      <strong>{program.price}</strong>
                    </div>

                    {program.note && <p>{program.note}</p>}
                  </div>
                ))}
              </div>
            </>
          )}

          <h2>Planning notes</h2>
          <p>{experience.planningNotes || defaultPlanningNotes}</p>
        </div>

        <aside className="detail-sidebar">
          <h3>Quick facts</h3>

          <dl>
            <div>
              <dt>Category</dt>
              <dd>{experience.category}</dd>
            </div>

            <div>
              <dt>Price</dt>
              <dd>{experiencePriceLabel(experience)}</dd>
            </div>

            <div>
              <dt>Group size</dt>
              <dd>{experience.groupSize}</dd>
            </div>

            <div>
              <dt>Duration</dt>
              <dd>{experience.duration}</dd>
            </div>

            <div>
              <dt>Setting</dt>
              <dd>{experience.setting}</dd>
            </div>
          </dl>

          <div className="detail-actions">
            {canUseBuilder && (
              <Link
                to={builderUrl}
                className="button primary full detail-cta-button"
              >
                Build an Event With This
              </Link>
            )}

            <Link
              to="/planning-assistance"
              className={`${canUseBuilder ? 'button secondary' : 'button primary'} full detail-cta-button`}
            >
              Get Planning Help
            </Link>
          </div>
        </aside>
      </section>
    </main>
  );
};

export default ProductPage;
